// Update the Footer component with new contact details
import React from 'react';
import { Link } from 'react-router-dom';
import { Stethoscope, Phone, Mail, MapPin, Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <Stethoscope size={32} className="text-secondary-500 mr-2" />
              <div>
                <h3 className="text-xl font-bold text-white">VET Explore</h3>
                <p className="text-xs text-secondary-500 -mt-1">Hub</p>
              </div>
            </div>
            <p className="text-gray-400 mb-4">
              Your trusted partner for BVSc admissions in India. We help aspiring veterinarians
              achieve their dreams through expert guidance and personalized support.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-secondary-500">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-secondary-500">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-secondary-500">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-secondary-500">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/colleges" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Colleges
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/counselling" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Admission Counselling
                </Link>
              </li>
              <li>
                <Link to="/services/application" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Application Assistance
                </Link>
              </li>
              <li>
                <Link to="/services/document" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Documentation Support
                </Link>
              </li>
              <li>
                <Link to="/services/interview" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Interview Preparation
                </Link>
              </li>
              <li>
                <Link to="/services/scholarship" className="text-gray-400 hover:text-secondary-500 transition-colors">
                  Scholarship Guidance
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Phone size={20} className="text-secondary-500 mr-3 mt-1" />
                <span className="text-gray-400">
                  <a href="tel:+918452055440" className="hover:text-secondary-500">
                    +91 8452 055 440
                  </a>
                </span>
              </li>
              <li className="flex items-start">
                <Mail size={20} className="text-secondary-500 mr-3 mt-1" />
                <span className="text-gray-400">
                  <a href="mailto:admissionsveterinary@gmail.com" className="hover:text-secondary-500">
                    admissionsveterinary@gmail.com
                  </a>
                </span>
              </li>
              <li className="flex items-start">
                <MapPin size={20} className="text-secondary-500 mr-3 mt-1" />
                <span className="text-gray-400">
                  BDA Complex, HSR Layout, Bengaluru, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        <hr className="border-gray-700 my-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} VET Explore Hub. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="text-gray-500 text-sm hover:text-secondary-500">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-500 text-sm hover:text-secondary-500">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;